module.exports = __webpack_public_path__ + "img/download_apple_store.ceb332de.svg";